import { getGdprCookie } from '../../projects/gdpr/domain/gdpr-provider';
import ReactDOM from 'react-dom';
import React from 'react';
import YoutubeVideo from './youtube-video';
import { getIsChina } from '../hidden-data-provider';
import ChinaMediaError from './china-media-error';

/**
 * Search for elements <div data-yt-title="..." data-yt-src="..."></div>
 * If GDPR is enabled ---> render youtube video, otherwise render message that is printed in master page in the hidden DIV.
 * https://wavesaudio.atlassian.net/browse/DSWEB-2203
 */
export const renderYoutubeVideos = () => {

    const isChina = getIsChina();

    const gdpr = getGdprCookie();
    const isVideoVisible = gdpr.IsFunctional;

    const $error = document.getElementById('gdpr-error');
    const error = ($error ? ($error.textContent || '') : '').trim();

    const $videos = document.querySelectorAll('[data-yt-src]');

    $videos.forEach($video => {

        const title = $video.getAttribute('data-yt-title') || '';
        const src = $video.getAttribute('data-yt-src') || '';
        const classes = $video.getAttribute('data-yt-classes') || undefined;

        // render youtube iframe
        ReactDOM.render(
            <React.StrictMode>
                {
                    !isChina &&
                    <YoutubeVideo
                        isError={ !isVideoVisible }
                        title={ title }
                        src={ src }
                        error={ error }
                        classes={ classes }
                    />
                }

                { isChina && <ChinaMediaError /> }
            </React.StrictMode>,
            $video
        );
    });
};

window.waves = window.waves || {};
window.waves.canRenderVideoByGDPR = () : boolean => {
    const gdpr = getGdprCookie();
    return gdpr.IsFunctional;
};

/*
window.waves.getGDPRErrorHTML = () : string => {
    const $error = document.getElementById('gdpr-error');
    return ($error ? ($error.textContent || '') : '').trim();
};*/